export const DEFAULT_COMPANY_LOGO = '/images/company-logo-placeholder.svg'
export const DEFAULT_COMPANY_BANNER = '/images/banner-default.svg'

// Language: typescript
